<ng-container *ngIf="authorization; else noAuth">
  <app-toolbar [back]="back" [destination]="destination" [title]="title" [user]="user"></app-toolbar>

  <div class="form" style="padding-bottom: 70px; max-width: 1000px">
    <div style="padding: 20px 30px;">
      <h3 style="text-align: center">Doctor SCCAI (sintomi dall'ultima settimana) - Clinico</h3>
    </div>
    <form [formGroup]="qForm" (ngSubmit)="onSubmit(qForm.value)">

      <div class="container && mat-elevation-z5">

        <div *ngFor="let question of dataSource">
          <mat-radio-group
            aria-labelledby="example-radio-group-label"
            class="example-radio-group">
            <ng-container *ngIf="question.position < 6">
              <label><h4>{{question.position}}. {{question.question}}</h4></label>
              <mat-radio-button [disableRipple]="true" #button (click)="checkState(button, question.position, question.answers)"
                              class="example-radio-button" (change)="setAnswer(answer, question.position, question.answers)"
                              *ngFor="let answer of question.answers" [value]="answer">
              {{answer}}
            </mat-radio-button>
            </ng-container>
            <ng-container *ngIf="question.position === 6">
              <label id="example-radio-group-label"><h4>{{question.position}}. A parte i Suoi sintomi intestinali, ha avuto qualcuno dei sintomi elencati a seguire?</h4></label>
              <label><h4>{{question.question}}</h4></label>
              <mat-radio-button [disableRipple]="true" #button (click)="checkState(button, question.position, question.answers)"
                                class="example-radio-button" (change)="setAnswer(answer, question.position, question.answers)"
                                *ngFor="let answer of question.answers" [value]="answer">
                {{answer}}
              </mat-radio-button>
            </ng-container>
            <ng-container *ngIf="question.position === 7">
              <label><h4>{{question.question}}</h4></label>
              <mat-radio-button [disableRipple]="true" #button (click)="checkState(button, question.position, question.answers)"
                                class="example-radio-button" (change)="setAnswer(answer, question.position, question.answers)"
                                *ngFor="let answer of question.answers" [value]="answer">
                {{answer}}
              </mat-radio-button>
              <ng-container *ngIf="question.answers[0].localeCompare('Si') === 0">
                <div style="max-width: 850px">
                  <br><strong>Nota:</strong> Se ha avuto arrossamento dell’occhio ed ha avuto in precedenza una diagnosi di uveite, episclerite o sclerite, ed ha una recidiva dei sintomi avvertiti, proceda con una visita Oculistica urgentemente
                </div>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="question.position >= 8">
              <label><h4>{{question.question}}</h4></label>
              <mat-radio-button [disableRipple]="true" #button (click)="checkState(button, question.position, question.answers)"
                                class="example-radio-button" (change)="setAnswer(answer, question.position, question.answers)"
                                *ngFor="let answer of question.answers" [value]="answer">
                {{answer}}
              </mat-radio-button>
            </ng-container>
          </mat-radio-group>
        </div>

      </div>


      <div style="text-align: center; padding-top: 50px">
        <ng-container *ngIf="submitted">
          <div style="justify-content: center; align-content: center; align-items: center; padding-bottom: 50px">
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          </div>
        </ng-container>

        <div style="text-align: center">
          <ng-container *ngIf="!show">
            <button  class="mat-elevation-z4" mat-raised-button type="submit" color="primary">Invia</button>
          </ng-container>
        </div>
      </div>

    </form>
  </div>
</ng-container>
<ng-template #noAuth>
  <app-toolbar [back]="back" [destination]="destination" [title]="'Accesso non autorizzato'" [user]="user"></app-toolbar>
  <div style="padding-bottom: 20px; padding-top: 20px; text-align: center;">
    <h4>
      L'accesso a questa pagina non è autorizzato. Torna alla home
    </h4>
    <button mat-raised-button color="warn" (click)="goHome()">Home</button>
  </div>
</ng-template>
